// composables/useMinScreenWidth.ts
import { onMounted, onUnmounted, ref } from "vue";

/**
 * Reactively returns true if the screen width is greater than or equal to the given width.
 *
 * @param {number} minWidth - The minimum screen width in pixels to compare against.
 * @returns {Ref<boolean>} - A reactive ref that updates on window resize.
 */
export function useMinScreenWidth(minWidth: number) {
  const matches = ref(false);

  const checkWidth = () => {
    matches.value = window.innerWidth >= minWidth;
  };

  onMounted(() => {
    checkWidth();
    window.addEventListener("resize", checkWidth);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", checkWidth);
  });

  return matches;
}
